export default __webpack_public_path__ + "locales/ja-JP/PaymentsEnterprise.json?hash=81cb816f27ed5abb34cb0a8ff9b75ddb";